function iniciarApp(){
  // Check for OAuth redirect code in URL (from Dropbox OAuth flow via localhost)
  const _oauthCode = new URLSearchParams(window.location.search).get('code');
  if(_oauthCode){
    // Clean URL without reloading
    window.history.replaceState({}, document.title, window.location.pathname);
    dbxTrocarCodigo(_oauthCode).then(()=>{ showPage('documentos',{isBootLink:true}); });
  }
  document.getElementById('loading').style.display='none';
  document.getElementById('main').style.display='flex';
  document.querySelectorAll('.page').forEach(p=>p.style.display='');
  const t=temaInicialGaturamo();applyTheme(t);
  const cfg=configEmpresaNormalizada(CACHE.config||{});CACHE.config={...(CACHE.config||{}),...cfg};
  const orgNome=normalizarNomeEmpresa(window.MarmoriaSaaS?.state.organization?.name);
  document.getElementById('sb-nome').textContent=PLATAFORMA_IDENTIDADE.commercialName||'Gaturamo';
  if(window.MarmoriaSaaS?.state.organization?.name)document.title=PLATAFORMA_IDENTIDADE.name;
  if(cfg.nome){document.getElementById('rel-nome-title').textContent=cfg.nome}
  atualizarQuadranteEmpresa(cfg);
  const authUser=typeof firebase.auth==='function'?firebase.auth().currentUser:null;
  document.getElementById('tb-user').textContent=authUser?.displayName||authUser?.email||cfg.consultor||'Daniel';
  renderIdentidadeAtiva();
  window.PhoneIntelligence?.attach(document);
  if(window.MARMORARIA_SAAS_MODE===true){const state=window.MarmoriaSaaS?.state||{},orgButton=document.getElementById('org-switcher');orgButton.style.display='';orgButton.textContent=state.contextMode==='platform'?'Central Master':state.contextMode==='support'?`Atendimento · ${state.supportSession?.ticketNumber||'chamado'}`:`Empresa · ${state.organization?.name||'Empresa'}`;document.getElementById('logout-btn').style.display=''}
  if(window.MarmoriaSaaS?.state.contextMode==='platform'){
    document.getElementById('sb-nome').textContent=PLATAFORMA_IDENTIDADE.commercialName||PLATAFORMA_IDENTIDADE.name;
    document.getElementById('sb-tenant').textContent='Central Master';
    const tenantInfo=document.getElementById('tb-tenant-info');if(tenantInfo)tenantInfo.hidden=true;
    document.getElementById('rel-nome-title').textContent=PLATAFORMA_IDENTIDADE.commercialName||PLATAFORMA_IDENTIDADE.name;
    document.querySelectorAll('[data-feature]').forEach(el=>{if(!(window.MARMORARIA_FEATURES||{})[el.dataset.feature])el.style.display='none'});
    aplicarVisibilidadePorPerfil();restoreSbGroups();try{montarRailNavegacao()}catch(e){console.warn('rail',e)}
    return;
  }
  // Feature flags — esconder elementos experimentais desativados
  const _feats=window.MARMORARIA_FEATURES||{};
  document.querySelectorAll('[data-feature]').forEach(el=>{if(!_feats[el.dataset.feature])el.style.display='none'});
  aplicarVisibilidadePorPerfil();
  configurarAcessoGaturamoPay();
  initMesSelect('caixa-mes');initMesSelect('pag-mes');
  buildStatusSelect();
  populateClientesDatalist();
  restoreSbGroups();try{montarRailNavegacao()}catch(e){console.warn("rail",e)}
  expandSbGroupFor(document.querySelector('.page.active')?.id?.replace('page-','')||'dashboard');
  updateBadges();
  renderDashboard();
  registrarUsoTenant('dashboard');
  renderQuickActions('dashboard');
  carregarMeuPerfil().catch(e=>console.warn('Perfil',e));
  // Resolve a rota solicitada antes de iniciar tarefas secundarias. Assim,
  // falhas de sincronizacao, notificacao ou catalogo nao prendem a interface
  // no Dashboard quando o usuario abriu um modulo por link direto.
  const settingsPath=location.pathname.startsWith('/configuracoes');
  const params=new URLSearchParams(window.location.search),paginaInicial=settingsPath?'config':(params.get('page')||(params.get('modo')==='op'?'operacional':''));
  if(paginaInicial&&PAGE_RENDER[paginaInicial]&&document.getElementById('page-'+paginaInicial))showPage(paginaInicial,{isBootLink:true});
  // Links vindos da Estação CAD abrem a ação exata da medição, sem o usuário
  // precisar procurar novamente o projeto ou o plano de corte no menu.
  const medicaoDireta=params.get('medicao'),nestingDireto=params.get('openNesting'),geometriaDireta=params.get('openGeometry'),fromCadProjeto=params.get('fromCad');
  if(paginaInicial==='medicao'&&(medicaoDireta||nestingDireto||geometriaDireta)){
    setTimeout(()=>{
      const id=nestingDireto||medicaoDireta;
      if(nestingDireto)openNestingModal(id);else if(geometriaDireta)abrirGeometriaDaMedicao(id,geometriaDireta);else openMedicaoForm(id);
      if(geometriaDireta&&fromCadProjeto)mostrarRetornoCad(fromCadProjeto,geometriaDireta);
      const limpa=new URL(location.href);limpa.searchParams.delete('medicao');limpa.searchParams.delete('openNesting');limpa.searchParams.delete('openGeometry');limpa.searchParams.delete('fromCad');history.replaceState({},document.title,limpa.toString());
    },120);
  }
  iniciarRealtime();
  reenviarAuditoriaPendente().catch(e=>console.warn('Reenvio da auditoria',e));
  executarMigracoesIniciais().catch(e=>console.warn('Migrações iniciais',e));
  processarNotificacoesLocais().catch(e=>console.warn('Notificações locais',e));
  const now=new Date();const mes=`${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}`;
  if(!CACHE.snapshots.find(s=>s.mes===mes))salvarSnapshot().catch(()=>{});
}

window.addEventListener('load',async()=>{
  if (!window.GestaoRuntimeReady) {
    document.getElementById('loading-msg').textContent='Não foi possível carregar todos os componentes. Recarregue a página para tentar novamente.';
    return;
  }
  const fbOk=await window._firebaseReady;
  const initial=window.MARMORARIA_FIREBASE_CONFIG;
  if(!fbOk||!initial){document.getElementById('loading-msg').textContent='Não foi possível iniciar o sistema. Verifique sua conexão e tente novamente.';return}
  try{
    firebase.initializeApp(initial);fdb=firebase.firestore();
    let limpezaOk=await resolverLimpezaPendente();
    if(!limpezaOk){
      // Contenção transitória (ex.: outra aba ainda fechando a conexão anterior) pode falhar na
      // primeira tentativa e resolver sozinha logo em seguida. Tenta mais uma vez antes de travar
      // o usuário numa tela sem saída.
      await new Promise(r=>setTimeout(r,3000));
      limpezaOk=await resolverLimpezaPendente();
    }
    if(!limpezaOk){mostrarTelaDeSeguranca({});return}
    await configurarPersistenciaOffline();await carregarSegurancaRemota();await aguardarAutenticacao()
  }
  catch(e){document.getElementById('loading-msg').textContent='O sistema está temporariamente indisponível. Tente novamente em alguns instantes.';console.error('Falha ao iniciar aplicação',e)}
});
function formatarIdentificacaoRelease(release){const plataforma=PLATAFORMA_IDENTIDADE.commercialName||PLATAFORMA_IDENTIDADE.name||'Plataforma';if(!release)return`${plataforma} · release indisponível`;const app=release.application||plataforma,version=release.version||'release indisponível',environment=release.environmentLabel||release.environment||'ambiente indisponível',commit=String(release.commit||'').slice(0,7)||'indisponível';return`${app} ${version} · ${environment} · ${commit}`}
var APP_RELEASE=null;
var APP_BUILD='release-indisponivel';
var APP_RELEASE_READY=window.PlatformRelease.getCurrentRelease().then(release=>{
  APP_RELEASE=release;
  APP_BUILD=release.version;
  window.PlatformRelease.applyEnvironmentBanner(release);
  const stamp=document.getElementById('build-stamp');
  if(stamp)stamp.textContent=formatarIdentificacaoRelease(release);
  console.info('Platform release',release);
  if('serviceWorker' in navigator&&location.protocol!=='file:'){
    navigator.serviceWorker.addEventListener('controllerchange',()=>{
      const key='sw_reloaded_'+release.commit;
      if(sessionStorage.getItem(key))return;
      sessionStorage.setItem(key,'1');
      location.reload();
    });
    return navigator.serviceWorker.register(`./service-worker.js?commit=${encodeURIComponent(release.commit)}`,{updateViaCache:'none'}).then(reg=>reg.update()).then(()=>release);
  }
  return release;
}).catch(error=>{
  const stamp=document.getElementById('build-stamp');
  if(stamp)stamp.textContent='release indisponível';
  console.error('Manifesto de release',error);
  return null;
});
window.addEventListener('offline',()=>{const t=document.getElementById('sync-text');if(t)t.textContent='Sem internet';toast('Sem internet. Evite fechar a aplicação até a conexão voltar.','error')});
window.addEventListener('online',()=>{setSync(false);reenviarAuditoriaPendente().catch(()=>{});toast('Conexão restaurada. Sincronizando dados...')});
window.addEventListener('unhandledrejection',event=>{
  const msg=String(event.reason?.message||event.reason||'');
  console.error('Operação não concluída',event.reason);
  if(msg.includes('PERMISSION_DENIED'))return;
  logErroFrontend('unhandledrejection',msg,{stack:event.reason?.stack||''});
  toast('Uma operação não foi concluída. Confira a conexão e tente novamente.','error');
});
